import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/register/page.jsx");
